import { render, staticRenderFns } from "./Sincronizar.vue?vue&type=template&id=b50d073c&"
import script from "./Sincronizar.vue?vue&type=script&lang=js&"
export * from "./Sincronizar.vue?vue&type=script&lang=js&"
import style0 from "./Sincronizar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports